<template>
  <div v-if="person" class="share">
      <social-sharing :url="`https://vkusomer.artlebedev.ru/accounts/${person.id}/`" :title="getTitle()" description="«Вкусомер» — это инструмент, позволяющий каждому проверить свой дизайнерский вкус." hashtags="like,design,test" inline-template>
        <div class="social">
          <network network="facebook">
            <div class="SocialMediaShareButton SocialMediaShareButton--facebook">
              <img src="/static/social-fb.svg">
            </div>
          </network>

          <network network="twitter">
            <div class="SocialMediaShareButton SocialMediaShareButton--twitter">
              <img src="/static/social-tw.svg">
            </div>
          </network>      

          <network network="vk">
            <div class="SocialMediaShareButton SocialMediaShareButton--vk">
              <img src="/static/social-vk.svg">
            </div>
          </network>

          <network network="googleplus">
            <div class="SocialMediaShareButton SocialMediaShareButton--googlePlus">
              <img src="/static/social-gl.svg">
            </div>
          </network>

          <div class="SocialMediaShareButton SocialMediaShareButton--livejournal">
            <a target="_blank" href="http://www.livejournal.com/update.bml?subject=Вкусомер&amp;event=%3Ca%20href%3D%22https://vkusomer.artlebedev.ru/>Вкусомер</a>">
              <span>
                <img src="/static/social-lj.svg">
              </span>
            </a>
          </div>
        </div>

      </social-sharing>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Share',
  computed: mapGetters({
    person: 'person',
  }),
  methods: {
    getTitle() {
      const etalon = this.person.compare_etalon >= 0 ? this.person.compare_etalon : 0;
      const percent = this.person.id === 7 ? 100 : etalon;
      return `${this.person.first_name || 'Неизвестный'} ${this.person.last_name} шарит в дизайне на ${percent}%`;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.share{
  transition: all .5s ease-in-out;
  width: 280px;
  margin: 0 auto;
  display: block;
  margin-top: 0;
  position: relative;
  text-align: center;
  border-radius: 10px;
  white-space: nowrap;
  padding: 5px 30px;

  .SocialMediaShareButton{
    transition: opacity .3s ease-in-out;
    display: inline-block;
    vertical-align: top;
    position: relative;
    cursor: pointer;
    opacity: .5;
    margin: 9px;

    &:hover{
      opacity: 1;
    }
    a{
      border-bottom: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// Share.vue?2bf023d7